import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBellFull = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_22667_165811)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12.744 0.488221C13.0094 0.0213519 13.5974 -0.138609 14.0572 0.130938C14.517 0.400485 14.6745 0.997469 14.4091 1.46434L13.8803 2.39423C15.5577 3.89972 16.0179 6.44378 14.8552 8.48863L11.4905 14.406L3.16509 9.52544L6.52978 3.60804C7.6925 1.56319 10.0925 0.695868 12.2152 1.41811L12.744 0.488221Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.16509 9.52544L1.5 8.54932C2.81321 8.19203 4.45617 7.25452 6.04897 4.4533L3.16509 9.52544Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4905 14.406L14.3747 9.33405C12.7819 12.1353 12.8037 14.0487 13.1556 15.3821L11.4905 14.406Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.37089 14.7381C4.45141 14.1991 4.13629 13.0054 4.66691 12.0717L7.99709 14.024C7.46605 14.9574 6.29036 15.2771 5.37089 14.7381Z",
				fill: "currentColor"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_22667_165811",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(0.5)"
		})
	}) })]
});
export default SvgBellFull;
